/**
 * An error class that represents an aborted operation.
 */
export class AbortError extends Error
{
    /**
     * Creates an error class that represents an aborted operation.
     */
    constructor(message: string = "Operation aborted.")
    {
        super(message);
        this.name = "AbortError";
    }
}
